import { render, staticRenderFns } from "./Personel.vue?vue&type=template&id=edffe47c"
import script from "./Personel.vue?vue&type=script&lang=js"
export * from "./Personel.vue?vue&type=script&lang=js"
import style0 from "./Personel.vue?vue&type=style&index=0&id=edffe47c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports